import ICultureSets from './interfaces/ICultureSets';
import ITranslations from './interfaces/ITranslations';
import Translations from './Translations';

export default class CultureSets implements ICultureSets {
    private cultureSets: { [culture: string]: ITranslations } = {};

    public hasCulture(culture: string): boolean {
        return culture in this.cultureSets;
    }

    public getCultures(): string[] {
        return Object.keys(this.cultureSets);
    }

    public addTranslations(culture: string, translations: { [key: string]: string}): void {
        if (this.hasCulture(culture)) {
            this.cultureSets[culture].appendTranslations(translations);
        } else {
            this.cultureSets[culture] = new Translations(translations);
        }
    }

    public getTranslations(culture: string): ITranslations {
        return this.cultureSets[culture];
    }
}
